import config from '@/config';
import { authService } from '@/services/authService';
import { AuthServiceEnum } from '@/util/auth/enums';
import { Actions } from '@/util/settings/enums';
import fetchWithToken from './authHelpers';
const actions = {
    async [Actions.LOGIN](context, loginType = AuthServiceEnum.LOGIN_REDIRECT) {
        try {
            await authService.login(loginType);
        }
        catch (error) {
            console.error('login', error);
        }
    },
    async callapi() {
        try {
            const data = await fetchWithToken(`${config.url.api.gmcConnectApi}/ping`);
            console.log('%c CALL API RESPONSE: ', 'background: #222; color: #bada55', data);
        }
        catch (error) {
            console.error('getCookie', error);
        }
    },
    async [Actions.GET_COOKIE_FROM_TOKEN]() {
        try {
            const data = await fetchWithToken(`${config.url.api.gmcConnectApi}/cookie`);
            console.log('%c GET COOKIE RESPONSE: ', 'background: #222; color: green', data);
        }
        catch (error) {
            console.error('getCookie', error);
        }
    },
    async [Actions.CREATE_ACCOUNT]() {
        try {
            const data = await fetchWithToken(`${config.url.api.gmcConnectApi}/account/create`, 'POST');
            console.log('%c CREATE ACCOUNT RESPONSE: ', 'background: #222; color: yellow', data);
        }
        catch (error) {
            console.error('createAccount', error);
        }
    },
    async [Actions.GET_TOKEN_SILENT]() {
        try {
            await authService.getTokenSilent(AuthServiceEnum.ACQUIRE_TOKEN_REDIRECT);
            console.log('%c GET TOKEN SILENT RESPONSE: ', 'background: #222; color: yellow', 'TOKEN SILENT SUCCESS ON PAGE LOAD');
        }
        catch (error) {
            console.error('GET TOKEN', error);
        }
    },
    async [Actions.SET_CONNECT_ID](context, connectId) {
        try {
            const response = await fetchWithToken(`${config.url.api.gmcConnectApi}/test/setconnectid`, 'POST', { connectId });
            const data = await response.json();
            console.log('%c SET_CONNECT_ID_RESPONSE: ', 'background: #222; color: purple', data);
        }
        catch (error) {
            console.error('SET_CONNECT_ID', error);
        }
    }
};
export default actions;
